import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';

function LoginForm({ onSuccess, onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const payload = new URLSearchParams();
    payload.append("username", email);
    payload.append("password", password);

    const res = await axios.post("https://fnm-backend.aibc-robotics.com/login", payload);

    // ✅ Shrani podatke le, če je vse ok
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userId", res.data.user_id);
    localStorage.setItem("email", res.data.email);

    onSuccess();
    onClose();
    toast.success("Uspešno si prijavil v platformo!");

  } catch (err) {
    if (err.response) {
      if (err.response.status === 403) {
        toast.error("Tvoj račun še ni potrjen. Počakaj, da ti admin odobri dostop.");
      } else if (err.response.status === 401) {
        toast.error("Nepravilna e-pošta ali geslo.");
      } else {
        toast.error("Napaka pri prijavi. Poskusi znova.");
      }
    } else {
      toast.error("Napaka pri povezavi s strežnikom.");
    }
    console.error(err);
  }
};




  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div onClick={onClose} className="absolute inset-0" />
      <div
        className="bg-white rounded-xl p-6 shadow-lg z-10 w-[300px]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold mb-4">Prijava</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="E-pošta"
            className="w-full p-2 border rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Geslo"
            className="w-full p-2 border rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
          >
            Prijavi se
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
